import { useEffect, useMemo, useState } from 'react';
import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer';
import Toast from '../../components/Toast';
import { getTelegramUsers, sendTelegramNews } from '../../services/TelegramNewsService';

function TelegramNews() {
    const [mode, setMode] = useState('all'); // 'all' | 'one'
    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [message, setMessage] = useState('');
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [sending, setSending] = useState(false);
    const [notification, setNotification] = useState({ type: '', text: '' });

    const canSend = useMemo(() => {
        if (!message.trim()) return false;
        if (mode === 'one' && !selectedUserId) return false;
        return true;
    }, [message, mode, selectedUserId]);

    useEffect(() => {
        setLoadingUsers(true);
        getTelegramUsers()
            .then(result => {
                setUsers(result || []);
                if ((result || []).length === 1) {
                    setSelectedUserId(String(result[0].id));
                }
            })
            .catch(err => {
                const errorMsg = err.response ? err.response.data : err.message;
                setNotification({ type: 'error', text: errorMsg || 'Erro ao carregar usuários do Telegram' });
            })
            .finally(() => setLoadingUsers(false));
    }, []);

    function onSubmit(e) {
        e.preventDefault();
        setNotification({ type: '', text: '' });

        if (!canSend) return;

        const sendToAll = mode === 'all';
        setSending(true);
        sendTelegramNews({
            sendToAll,
            userId: sendToAll ? undefined : selectedUserId,
            message
        })
            .then(result => {
                if (result && result.failed && result.failed > 0) {
                    setNotification({
                        type: 'warning',
                        text: `Enviado: ${result.sent}. Falhas: ${result.failed}.`
                    });
                } else {
                    setNotification({ type: 'success', text: `Mensagem enviada com sucesso! (${result.sent || 1})` });
                }
            })
            .catch(err => {
                const errorMsg = err.response ? err.response.data : err.message;
                setNotification({ type: 'error', text: errorMsg || 'Erro ao enviar mensagem' });
            })
            .finally(() => setSending(false));
    }

    return (
        <>
            <Menu />
            <main className="content">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <h1 className="h4">Notícias no Telegram</h1>
                        <p className="mb-0 text-muted">
                            Envie uma mensagem para todos os usuários que possuem Telegram configurado, ou para apenas um usuário.
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="card card-body border-0 shadow mb-4">
                            <form onSubmit={onSubmit}>
                                <div className="row">
                                    <div className="col-12 mb-3">
                                        <label className="form-label d-block">Destino</label>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="mode"
                                                id="modeAll"
                                                value="all"
                                                checked={mode === 'all'}
                                                onChange={() => setMode('all')}
                                            />
                                            <label className="form-check-label" htmlFor="modeAll">Todos os usuários</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="mode"
                                                id="modeOne"
                                                value="one"
                                                checked={mode === 'one'}
                                                onChange={() => setMode('one')}
                                            />
                                            <label className="form-check-label" htmlFor="modeOne">Apenas um usuário</label>
                                        </div>
                                        <div className="mt-2 text-muted">
                                            {loadingUsers ? 'Carregando lista de usuários...' : `Usuários com Telegram: ${users.length}`}
                                        </div>
                                    </div>
                                </div>

                                {mode === 'one' && (
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label htmlFor="userId" className="form-label">Usuário</label>
                                            <select
                                                id="userId"
                                                className="form-select"
                                                value={selectedUserId}
                                                onChange={e => setSelectedUserId(e.target.value)}
                                                disabled={loadingUsers || users.length === 0}
                                            >
                                                <option value="">
                                                    {users.length ? 'Selecione um usuário' : 'Nenhum usuário com Telegram configurado'}
                                                </option>
                                                {users.map(u => (
                                                    <option key={u.id} value={String(u.id)}>
                                                        {u.name ? `${u.name} — ${u.email}` : u.email}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                )}

                                <div className="row">
                                    <div className="col-12 mb-3">
                                        <label htmlFor="message" className="form-label">Mensagem</label>
                                        <textarea
                                            id="message"
                                            className="form-control"
                                            rows="6"
                                            placeholder="Digite a notícia que será enviada pelo Telegram…"
                                            value={message}
                                            onChange={e => setMessage(e.target.value)}
                                        />
                                        <small className="text-muted d-block mt-2">
                                            Dica: mantenha a mensagem curta para evitar cortes no Telegram.
                                        </small>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-3">
                                        <button
                                            type="submit"
                                            className="btn btn-gray-800 mt-2 animate-up-2"
                                            disabled={!canSend || sending}
                                        >
                                            {sending ? 'Enviando...' : 'Enviar no Telegram'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <Footer />
            </main>
            <Toast type={notification.type} text={notification.text} />
        </>
    );
}

export default TelegramNews;




